export default __webpack_public_path__ + "static/media/cropped-Logo-PNG.9ff4028e.png";